import { Component, ElementRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CustomerdealService } from './service/customerdeal.service';
import { Customerdeal } from '@src/app/models/customerdeal';
import { ActivatedRoute } from '@angular/router';
import { Project } from '@src/app/models/project';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerdeal',
  templateUrl: './customerdeal.component.html',
  styleUrls: ['./customerdeal.component.css']
})
export class CustomerdealComponent implements OnInit, OnChanges{
  customerId:string;
  delaList:Customerdeal[];
  dealProjects:Project[];
  @Input() modalDeal:Customerdeal;
  @Output() dealcount:number;
  showSpinner:boolean=false;
  showDeleteConfirm:boolean;
  @ViewChild('closedealmodal',{static: true}) closedealmodal: ElementRef;
  @ViewChild('deletemodalclose',{static: true}) deletemodalclose: ElementRef;
  constructor(
    private cdsrv:CustomerdealService,
    private route:ActivatedRoute
    ){}
  
  ngOnInit(): void {
    this.dealProjects=[];
    
    this.customerId = this.route.snapshot.paramMap.get('customerId').split('_')[0];
   
    let now = new Date().toISOString();
        this.cdsrv.getProjects(this.customerId,now).pipe(untilDestroyed(this)).subscribe(data=>{
          
          data.forEach(project=>{
            if(project.dealId !=undefined && this.modalDeal.dealId && project.dealId.split('_')[0]==this.modalDeal.dealId.split('_')[0]){
              this.dealProjects.push(project); 
            }
          });
          this.dealcount=this.dealProjects.length;
        });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.modalDeal && changes.modalDeal.currentValue != undefined){
      this.ngOnInit();
    }
  }


  //Add deal
  addDeal(){
    this.showSpinner=true;
    this.modalDeal.customerId=this.customerId;
    this.cdsrv.createDeal(this.modalDeal).pipe(untilDestroyed(this)).subscribe(data=>{
      this.modalDeal.dealId=data.dealId;
      this.delaList.push(this.modalDeal);
      this.modalDeal=new Customerdeal();
      this.showSpinner=false;
    }
    );
  }
  openDeal(deal:Customerdeal){
    this.modalDeal=deal;
    this.modalDeal.customerId=this.customerId;
  }

  //Update deal
  updateDeal(){
    this.showSpinner=true;
    this.cdsrv.updateDeal(this.modalDeal).pipe(untilDestroyed(this)).subscribe(data=>{
      this.delaList.forEach((deal,index)=>{
        if(deal.dealId==this.modalDeal.dealId){
          this.modalDeal.dealId=data;
          this.delaList[index]=this.modalDeal;
        }
      } );
      this.modalDeal=new Customerdeal();
      this.closedealmodal.nativeElement.click();
      this.showSpinner=false;
    });
  }

  //Delete deal
  deleteDeal(){
    this.showSpinner=true;
    this.cdsrv.deleteDeal(this.modalDeal).pipe(untilDestroyed(this)).subscribe(data=>{
      this.delaList.forEach((deal,index)=>{
        if(deal.dealId==this.modalDeal.dealId){
          this.delaList.splice(index,1);
        }
      } );
      this.modalDeal=new Customerdeal();
      this.deletemodalclose.nativeElement.click();
      this.showSpinner=false;
    });
  }


}
